export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.dashboards",
        isTitle: true
    },
    {
        id: 10,
        label: "menuitems.dashboards.users",
        icon: "bx bx-user-circle",
        link: "/dashboard/users",
    },
    {
        id: 11,
        label: "menuitems.dashboards.financial",
        icon: "bx bx-dollar-circle",
        link: "/dashboard/financials",
    },
    {
        id: 12,
        label: "menuitems.dashboards.likes",
        link: "/dashboard/likes",
        icon: "bx bxs-like",
    },
    {
        id: 13,
        label: "menuitems.dashboards.score",
        link: "/dashboard/score",
        icon: "bx bxs-coin-stack",
    },
    {
        id: 14,
        label: "menuitems.dashboards.reviews",
        link: "/dashboard/reviews",
        icon: "bx bx-flag-alt",
    },
    {
        id: 15,
        label: "menuitems.dashboards.firebase",
        link: "/dashboard/firebase",
        icon: "bx bxs-package",
    },
    {
        id: 2,
        label: "menuitems.members.text",
        isTitle: true
    },
    {
        id: 20,
        label: "menuitems.members.search",
        icon: "bx bx-search-alt",
        link: "/users/search",
    },
    /*{
        id: 22,
        label: "menuitems.members.fix_qrIndex",
        icon: "bx bx-trending-up",
        link: "/users/fix-qrindex",
    },
    {
        id: 23,
        label: "menuitems.members.fix_event_users",
        icon: "bx bxs-like",
        link: "/users/fix-event-users",
    },*/
    {
        id: 24,
        label: "menuitems.members.beautiful_users",
        icon: "bx bxs-coin-stack",
        link: "/users/beautiful-users",
    },
    {
        id: 25,
        label: "menuitems.members.specials_users",
        icon: "bx bxs-coin-stack",
        link: "/users/specials-users",
    },
    {
        id: 7,
        label: "menuitems.moderation.text",
        isTitle: true
    },
    {
        id: 70,
        label: "menuitems.members.media",
        icon: "bx bx-image-alt",
        link: "/users/media",
    },
    {
        id: 75,
        label: "menuitems.members.featured_media",
        icon: "bxs bxs-video",
        link: "/users/featured-media",
    },
    {
        id: 71,
        label: "menuitems.members.videolikes",
        icon: "bxs bxs-video",
        link: "/users/videolikes",
    },
    {
        id: 72,
        label: "menuitems.members.updates",
        icon: "bx bxs-edit",
        link: "/users/updates",
    },
    {
        id: 74,
        label: "menuitems.moderation.checks",
        icon: "bx bxs-check",
        link: "/moderation/checks",
    },
    {
        id: 75,
        label: "menuitems.system.ai_stats",
        link: "/system/ai-stats",
        icon: "bx bx-injection",
    },
    {
        id: 3,
        label: "menuitems.support.text",
        isTitle: true
    },
    {
        id: 30,
        label: "menuitems.support.tickets",
        icon: "bx bx-support",
        link: "/support/tickets",
    },
    {
        id: 31,
        label: "menuitems.support.reports",
        icon: "bx bx-flag-alt",
        link: "/support/reports",
    },
    {
        id: 32,
        label: "menuitems.support.store_reviews",
        icon: "bx bxs-like",
        link: "/support/store-reviews",
    },
    {
        id: 4,
        label: "menuitems.marketing.text",
        isTitle: true
    },
    {
        id: 40,
        label: "menuitems.marketing.installs",
        icon: "bx bx-stats",
        link: "/marketing/installs",
    },
    {
        id: 41,
        label: "menuitems.marketing.leads",
        link: "/marketing/leads",
        icon: "bx bx-signal-4",
    },
    {
        id: 42,
        label: "menuitems.marketing.updates",
        link: "/marketing/updates",
        icon: "bx bx-signal-4",
    },
    {
        id: 43,
        label: "menuitems.marketing.uninstalls",
        link: "/marketing/uninstalls",
        icon: "bxs bxs-package",
    },
    {
        id: 5,
        label: "menuitems.finance.text",
        isTitle: true
    },
    {
        id: 50,
        label: "menuitems.finance.transactions",
        icon: "bx bxs-coin-stack",
        link: "/finance/transactions",
    },
    {
        id: 51,
        label: "menuitems.finance.subscriptions",
        link: "/finance/subscriptions",
        icon: "bx bxs-package",
    },
    {
        id: 52,
        label: "menuitems.finance.packs",
        link: "/finance/packs",
        icon: "bx bxs-package",
    },
    {
        id: 53,
        label: "menuitems.finance.stats",
        link: "/finance/stats",
        icon: "bx bx-list-check",
    },
    {
        id: 54,
        label: "menuitems.finance.priceGroups",
        link: "/finance/prices-test",
        icon: "bx bx-injection",
    },
    {
        id: 55,
        label: "menuitems.finance.slGroups",
        link: "/finance/slgroups",
        icon: "bx bx-injection",
    },
    {
        id: 56,
        label: "menuitems.finance.pmGroups",
        link: "/finance/pmgroups",
        icon: "bx bx-injection",
    },
    {
        id: 57,
        label: "menuitems.finance.vat_generator",
        link: "/finance/vat",
        icon: "bx bxs-coin-stack",
    },
    {
        id: 6,
        label: "menuitems.system.text",
        isTitle: true,
    },
    {
        id: 60,
        label: "menuitems.system.actions",
        link: "/system/actions",
        icon: "bx bxs-flask",
    },
    {
        id: 61,
        label: "menuitems.system.notifications",
        link: "/system/notifications",
        icon: "bx bx-bell",
    },
    {
        id: 62,
        label: "menuitems.system.emails",
        link: "/system/emails",
        icon: "bx bx-mail-send",
    },
    {
        id: 63,
        label: "menuitems.system.generator",
        link: "/system/generator",
        icon: "bx bx-injection",
    },
    {
        id: 64,
        label: "menuitems.system.actions_generator",
        link: "/system/answers",
        icon: "bx bx-injection",
    },
    {
        id: 65,
        label: "menuitems.system.ai_generator",
        link: "/system/ai-generator",
        icon: "bx bx-injection",
    }
];

